import { mapGetters } from "vuex";
import { mask } from "./mask";
import { getFieldType, isEmptyValue } from "../utils/productChangeLogs";

// Formatação dos valores do log de alterações exibidos na tabela. O relatório
// é gerado pelo backend, que precisa acompanhar estas mesmas regras.
const productChangeLog = {
  mixins: [mask],

  computed: {
    ...mapGetters(["preferences", "payments"])
  },

  methods: {
    formatChangeDate(date) {
      return this.moment
        .utc(date)
        .add(this.preferences.timezone, "h")
        .format("DD/MM/YY HH:mm:ss");
    },

    translateChange(group, value) {
      const key = `productChangeLogs.${group}.${value}`;
      return this.$te(key) ? this.$t(key) : value || "-";
    },

    formatChangeValue(value, field) {
      if (isEmptyValue(value)) return "-";

      const type = getFieldType(field);

      if (type === "money") {
        const amount = Number(value);
        if (isNaN(amount)) return String(value);
        return `${this.payments.currencySymbol} ${this.formatMoney(amount)}`;
      }

      if (type === "percent") {
        const amount = Number(value);
        return isNaN(amount) ? String(value) : `${amount}%`;
      }

      if (type === "date") {
        const parsed = this.moment.utc(value);
        return parsed.isValid() ? parsed.format("DD/MM/YY") : String(value);
      }

      if (type === "catalog")
        return this.translateChange("catalogStates", value);

      return String(value);
    }
  }
};

export { productChangeLog };
